import { Component, Vue } from 'vue-property-decorator'
import CABG1030ViewModel from './CABG1030ViewModel'
import CABG1030Service from './CABG1030Service'
import { FormatConstants } from '@/common/FormatConstants'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import CommonUtil from '@/common/utils/CommonUtil'
import $ from 'jquery'
import ValidateUtil from '@/common/utils/ValidationUtil'
import Store from '@/common/utils/Store'
import TransportService from '@/common/TransportService'
import { fixedContent } from '@/assets/js/main.js'
import { FullPageLoading } from '@/components/common/loading/full-page-loading'
@Component({
  name: 'CABG1030',
  components: {}
  })
export default class CABG1030Controller extends Vue {
  private isCompleteLoading = false
  private CommonConstants = CommonConstants
  private cabg1030Service: CABG1030Service = new CABG1030Service()
  private FormatConstants = FormatConstants
  private DEFAULT_YEAR_SELECTED = 0
  private CHANGE_IN_INVESTMENT_RETURN_SCALE_VALUE = 5
  private DISTRIBUTION_INVESTMENT_RETURN_SCALE_VALUE = 6
  private referenceDate = ''
  private rateUnit = ''
  private ValidateUtil = ValidateUtil
  private cabg1030ViewModel: CABG1030ViewModel = {
    critDay: '',
    operatYieldInfo: {
      fstPay: '',
      fstPayUnit: '%',
      latestOneYear: '',
      latestOneYearUnit: '%'
    },
    operatYieldTransInfo: {
      transInfoLst: [
        {
          critYearMon: '',
          yieldVal: null,
          yieldValUnit: ''
        }
      ]
    },
    allJoinerOperatYieldDistInfo: {
      rateForLessThanNeg10Per: null,
      rateForNeg10PerToNeg9Per: null,
      rateForNeg9PerToNeg8Per: null,
      rateForNeg8PerToNeg7Per: null,
      rateForNeg7PerToNeg6Per: null,
      rateForNeg6PerToNeg5Per: null,
      rateForNeg5PerToNeg4Per: null,
      rateForNeg4PerToNeg3Per: null,
      rateForNeg3PerToNeg2Per: null,
      rateForNeg2PerToNeg1Per: null,
      rateForNeg1PerTo0Per: null,
      rateFor0PerTo1Per: null,
      rateFor1PerTo2Per: null,
      rateFor2PerTo3Per: null,
      rateFor3PerTo4Per: null,
      rateFor4PerTo5Per: null,
      rateFor5PerTo6Per: null,
      rateFor6PerTo7Per: null,
      rateFor7PerTo8Per: null,
      rateFor8PerTo9Per: null,
      rateFor9PerTo10Per: null,
      rateForLessThan10Per: null,
      operatYieldValPosition: null,
      basicDate: ''
    },
    changeInInvestmentReturnData: [],
    distributionInvestmentReturnData: [],
    rateUnit: '',
    enableLegendChart: true
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      fixedContent()
      $('.highcharts-range-selector').attr('tabindex', '-1')
    })
    if (this.cabg1030ViewModel.changeInInvestmentReturnData?.length > 0 ||
        this.cabg1030ViewModel.distributionInvestmentReturnData?.length > 0
    ) {
      window.addEventListener('orientationchange', this.refreshPage);
    }
  }

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.refreshPage);
  }

  private refreshPage() {
    location.reload();
  }
  /**
   * 初期処理
   */
  private async init() {
    // 共通メソッド「ローディング表示」を呼び出す。
    const loading = new FullPageLoading()
    loading.show()

    const [
      caba1030ResponseModel,
      caba1031ResponseModel
    ] = await Promise.all([
      this.cabg1030Service.callAPICABA1030(),
      this.cabg1030Service.callAPICABA1031()
    ])

    fixedContent()

    // 共通メソッド「ローディングクローズ」を呼び出す。
    loading.close()

    if (CommonUtil.isNotEmpty(caba1030ResponseModel.operatYieldInfo)) {
      this.cabg1030ViewModel.operatYieldInfo =
        caba1030ResponseModel.operatYieldInfo
    }
    if (caba1031ResponseModel.operatYieldTransInfo) {
      this.cabg1030ViewModel.operatYieldTransInfo =
        caba1031ResponseModel.operatYieldTransInfo
    } else {
      this.cabg1030ViewModel.operatYieldTransInfo = null
    }

    if (caba1030ResponseModel.allJoinerOperatYieldDistInfo) {
      this.cabg1030ViewModel.allJoinerOperatYieldDistInfo =
        caba1030ResponseModel.allJoinerOperatYieldDistInfo
    } else {
      this.cabg1030ViewModel.allJoinerOperatYieldDistInfo = null
    }

    // prepare data for chart ChangeInInvestmentReturn
    if (
      CommonUtil.isNotEmpty(
        this.cabg1030ViewModel.operatYieldTransInfo?.transInfoLst
      ) &&
      CommonUtil.isNotNullArray(
        this.cabg1030ViewModel.operatYieldTransInfo.transInfoLst,
        ['yieldVal']
      )
    ) {
      this.cabg1030ViewModel.rateUnit =
        this.cabg1030ViewModel.operatYieldTransInfo.transInfoLst[0].yieldValUnit
      this.cabg1030ViewModel.operatYieldTransInfo.transInfoLst.forEach(
        (item) => {
          const convert = item.critYearMon.replace('-', '/') + '/28'
          const tem = Date.parse(convert)
          this.cabg1030ViewModel.changeInInvestmentReturnData.push([
            tem,
            CommonUtil.roundNumber(
              item.yieldVal,
              FormatConstants.INVEST_WITHOUT_UNIT
            )
          ])
        }
      )
    }

    // prepare data for DistributionInvestmentReturn
    const allJoinerOperatYieldDistInfoValue =
      this.cabg1030ViewModel.allJoinerOperatYieldDistInfo !== null
        ? Object.values(this.cabg1030ViewModel.allJoinerOperatYieldDistInfo)
        : []
    const data = []
    let isShowChart = false
    for (let i = 0; i <= allJoinerOperatYieldDistInfoValue.length - 3; i++) {
      if (allJoinerOperatYieldDistInfoValue[i] !== null) {
        isShowChart = true
        break
      }
    }

    if (isShowChart) {
      for (let i = 0; i <= allJoinerOperatYieldDistInfoValue.length - 3; i++) {
        const dataChart = {
          y: CommonUtil.roundNumber(
            allJoinerOperatYieldDistInfoValue[i],
            FormatConstants.INVEST_WITHOUT_UNIT
          ),
          color:
            i ===
            this.cabg1030ViewModel.allJoinerOperatYieldDistInfo
              .operatYieldValPosition
              ? '#E6465A'
              : '#A4DCF7'
        }
        data.push(dataChart)
      }

      if (
        this.cabg1030ViewModel.allJoinerOperatYieldDistInfo
          .operatYieldValPosition === null ||
        this.cabg1030ViewModel.allJoinerOperatYieldDistInfo
          .operatYieldValPosition > 21 ||
        this.cabg1030ViewModel.allJoinerOperatYieldDistInfo
          .operatYieldValPosition < 0
      ) {
        this.cabg1030ViewModel.enableLegendChart = false
      }
    }

    this.cabg1030ViewModel.distributionInvestmentReturnData = data

    // prepare data for message

    this.referenceDate = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    )?.userInfo.referenceDate
    this.isCompleteLoading = true
  }

  /**
   *  「運用状況（資産）」（CABG1010）画面へ遷移する。
   */
  private gotoCABG1010() {
    this.$router.push({ name: 'cabg1010' })
  }

  /**
   *  「運用状況（掛金）」（CABG1020）画面へ遷移する。
   */
  private gotoCABG1020() {
    this.$router.push({ name: 'cabg1020' })
  }

  /**
   * 外部サイト：JIS＆Tログインを別タブで表示する。
   * @param transportUrl
   */
  private gotoJIST(transportUrl, paramEvent) {
    if (CommonUtil.isGuestUser()) {
      const message = CommonUtil.getMessage('MSGCABG1030WF001', [])
      const messageErrorArr = []
      messageErrorArr.push({
        code: 'MSGCABG1030WF001',
        message: message,
        url: ''
      })
      Store.setResponseErrors(messageErrorArr)
    } else {
      TransportService.callAPITransport(transportUrl, null, null)
      CommonUtil.gotoJISTSite(paramEvent)
    }
  }
}
